// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1aJUq","name":"ConsentHeader_name__2tE5L","birthday":"ConsentHeader_birthday__2yl_L","skeleton":"ConsentHeader_skeleton__1_BQz"};